export default __webpack_public_path__ + "static/media/logo-AW.d6345168.svg";